// extracted by mini-css-extract-plugin
export default {"checkboxForm":"Checkbox_checkboxForm__uoR2P"};